var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://westpex.co.id/","target":"_blank"}},[_vm._v("Westpex ")]),_c('span',[_vm._v("| All Rights Reserved")])])])}
var staticRenderFns = []

export { render, staticRenderFns }